<template>
    <div class="profile__avatar text-xs-center"
         :class="{'avatar--default': !image}"
         :style="{'background-image': `url(${String(image).includes('data:image') ? image : (!!image) ? url + image : '/icons/user.svg'})`}"
    >
        <v-layout row class="profile__avatar-controls align-center">
            <v-flex class="profile__avatar-change ml-3">
                <linkIcon v-if="this.$route.name === 'profile'" icon="upload" class="mr-4">{{ $t("Изменить фото") }}
                    <label class="label_image" for="input_image">
                        <InputImage />
                    </label>
                </linkIcon>
            </v-flex>
            <v-flex class="profile__avatar-zoom mr-3 text-xs-right">
                <svg v-svg
                     symbol="zoom"
                     size="32 32"
                     class="icon"
                     role="presentation"
                     data-test="zoom-avatar"
                     @click="OPEN_MODAL('avatar_modal')"
                />
            </v-flex>
        </v-layout>
        <div v-if="image_error" class="red--text avatar__error-title"> {{ image_error }} </div>
        <v-dialog :value="avatar_modal" persistent content-class="scrolled-dialog">
            <avatarModal v-if="avatar_modal" :image="image" />
        </v-dialog>
    </div>
</template>

<script>
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import InputImage from '@/components/ui/inputs/base/input_image';
import avatarModal from '@/components/blocks/avatar/avatar_modal';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    linkIcon,
    InputImage,
    avatarModal,
  },
  props: {
    image: {
      type: String,
    },
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('common/modals', [
      'avatar_modal',
    ]),
    ...mapGetters('profile/user', ['image_error']),
  },
  methods: {
    ...mapMutations('common/modals', [
      'OPEN_MODAL',
    ]),
  },
};
</script>

<style lang='less'>
.profile__avatar {
  background-repeat: no-repeat;
  background-size: cover;
  max-height: 100vmin;
}

.opacity-0 {
  opacity: 0;
}
</style>
